/**
 * MP Lead Form — step radios, deep-links, submit labels, success path.
 * #mp-lead-form → trade; #mp-lead-form-project → project
 */
(function () {
  var HASH_TRADE = '#mp-lead-form';
  var HASH_PROJECT = '#mp-lead-form-project';
  var STORAGE_KEY = 'mpLeadFormPath';
  var TRADE = 'trade';
  var PROJECT = 'project';

  function pathLabels(value) {
    if (value === TRADE) return 'Apply for a Trade Account';
    if (value === PROJECT) return 'Request Project Pricing';
    return value || '';
  }

  function setStep2Enabled(root, enabled) {
    var step2 = root.querySelector('[data-mp-lead-step2]');
    if (!step2) return;
    step2.hidden = !enabled;
    var fields = step2.querySelectorAll('input, select, textarea, button');
    fields.forEach(function (el) {
      el.disabled = !enabled;
    });
  }

  function updateSubmitLabel(root, value) {
    var labelEl = root.querySelector('[data-mp-lead-submit-label]');
    if (!labelEl) return;
    var trade = root.getAttribute('data-mp-lead-submit-trade') || 'Send Trade Application';
    var project = root.getAttribute('data-mp-lead-submit-project') || 'Request Project Pricing';
    labelEl.textContent = value === PROJECT ? project : trade;
  }

  function selectPath(root, value) {
    var radios = root.querySelectorAll('[data-mp-lead-path]');
    var matched = false;
    radios.forEach(function (radio) {
      radio.checked = radio.value === value;
      if (radio.checked) matched = true;
    });
    var hidden = root.querySelector('[data-mp-lead-request-type]');
    if (hidden) hidden.value = pathLabels(value);
    setStep2Enabled(root, matched);
    if (matched) {
      updateSubmitLabel(root, value);
      try {
        sessionStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
        /* ignore */
      }
    }
    return matched;
  }

  function pathFromHash() {
    var hash = window.location.hash;
    if (hash === HASH_PROJECT) return PROJECT;
    if (hash === HASH_TRADE) return TRADE;
    return null;
  }

  function applyHash(root) {
    var path = pathFromHash();
    if (!path) return;
    selectPath(root, path);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function applySuccessCopy(root) {
    var card = root.querySelector('[data-mp-lead-success]');
    if (!card) return;
    var path = PROJECT;
    try {
      path = sessionStorage.getItem(STORAGE_KEY) || TRADE;
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      path = TRADE;
    }
    var titleTpl =
      path === PROJECT
        ? root.querySelector('[data-mp-lead-success-project-title]')
        : root.querySelector('[data-mp-lead-success-trade-title]');
    var bodyTpl =
      path === PROJECT
        ? root.querySelector('[data-mp-lead-success-project-body]')
        : root.querySelector('[data-mp-lead-success-trade-body]');
    var titleEl = card.querySelector('[data-mp-lead-success-title]');
    var bodyEl = card.querySelector('[data-mp-lead-success-text]');
    if (titleEl && titleTpl) titleEl.textContent = titleTpl.textContent.trim();
    if (bodyEl && bodyTpl) bodyEl.textContent = bodyTpl.textContent.trim();
  }

  function initForm(root) {
    if (!root || root.getAttribute('data-mp-lead-ready') === '1') return;
    root.setAttribute('data-mp-lead-ready', '1');

    applySuccessCopy(root);

    var form = root.querySelector('form');
    if (form && form.querySelector('.mp-lead-form__error-banner')) {
      form.classList.add('mp-lead-form__form--has-errors');
    }

    /* Start with step 2 closed until a radio (or hash) selects a path */
    setStep2Enabled(root, false);

    var radios = root.querySelectorAll('[data-mp-lead-path]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        selectPath(root, radio.value);
      });
    });

    if (form) {
      form.addEventListener('submit', function () {
        var checked = root.querySelector('[data-mp-lead-path]:checked');
        if (!checked) return;
        try {
          sessionStorage.setItem(STORAGE_KEY, checked.value);
        } catch (e) {
          /* ignore */
        }
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href="' + HASH_TRADE + '"], a[href="' + HASH_PROJECT + '"]');
      if (!link) return;
      window.setTimeout(function () {
        applyHash(root);
      }, 0);
    });

    window.addEventListener('hashchange', function () {
      applyHash(root);
    });

    applyHash(root);
  }

  function boot() {
    document.querySelectorAll('[data-mp-lead-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mp-lead-form]');
    if (root) {
      root.removeAttribute('data-mp-lead-ready');
      initForm(root);
    }
  });
})();
